import type { AlertEvent, ServiceSummary } from '@apm/contracts';

/** 선택한 서비스 알림과 어느 서비스에도 속하지 않는 공통 알림을 함께 본다. */
export function alertsForService(alerts: readonly AlertEvent[], service: string): AlertEvent[] {
  if (service === '') return [...alerts];
  return alerts.filter((alert) => alert.service === service || alert.service === undefined);
}

/** 헤더 숫자는 서비스 API의 같은 시점 수치를 더한다. */
export function selectionSummary(rows: readonly ServiceSummary[], service: string) {
  let instances = 0;
  let requests = 0;
  for (const row of rows) {
    if (service !== '' && row.service !== service) continue;
    instances += row.instances.total;
    requests += row.last5m.requests;
  }
  return { instances, requests };
}
